<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="5">
          <b-form-group>
            <label>Match Size</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.matchSize"
              :min="matchSizeMin"
              :max="matchSizeMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group>
            <label>Match Group</label>
            <b-form-select
              id="match-groups"
              v-model="settingsUser.matchGroup"
              :options="matchGroups"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group v-if="true">
            <label
              v-for="(aToggle, i) in toggles"
              class="notification"
              :value="aToggle.name"
              :key="`tog_${i}`"
            >
              <div class="toggler" :class="[aToggle.value ? 'bg' : '']">
                <div
                  class="slider"
                  :class="[aToggle.value ? 'btns' : '']"
                ></div>
              </div>
              <div class="notification-content">
                <h6>{{ aToggle.name }}</h6>
                <p>
                  {{ aToggle.text }}
                </p>
              </div>
              <input
                type="checkbox"
                class="invisible"
                v-model="aToggle.value"
              />
            </label>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import { mapGetters } from "vuex";
export default {
  name: "Settings_MatchGame",
  mixins: [ResourceBlockSettings],
  data() {
    return {
      settingsUser: {
        matchSize: 1,
        matchGroup: "fruits"
      },
      //****** App Specific
      matchSizeMin: 2,
      matchSizeMax: 5,
      matchGroups: [
        { value: "fruits", text: "Fruits" },
        { value: "animals", text: "Animals" },
        { value: "logos", text: "Logos" }
      ],
      value: 0,
      toggles: [
        {
          name: "Sound",
          property: "_isSoundOn",
          type: "btns",
          text: "Turn on the Sound",
          value: false
        },
        {
          name: "Display Stats",
          property: "_isDisplayStats",
          type: "btns",
          text: "Displays # of [Turns] and [Total Time]",
          value: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
